var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "fixed-grid has-12-cols" }, [
        _c("div", { staticClass: "grid" }, [
          !!_vm.isAvailableItemsOpen || !!_vm.isAvailableMainActive
            ? _c(
                "article",
                {
                  staticClass:
                    "tile py-0 my-0 is-child box cell is-col-span-5 pt-1",
                  class:
                    !!_vm.isAvailableItemsOpen || !!_vm.isAvailableMainActive
                      ? "is-col-span-5"
                      : "is-col-span-0",
                },
                [
                  _c(
                    "div",
                    { staticClass: "is-flex is-justify-content-space-between" },
                    [
                      _vm.selectedAddItemsTab == _vm.addItemsTabs.butterfly.key
                        ? _c(
                            "div",
                            { staticClass: "is-flex is-align-items-center" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "px-3 is-size-4 has-text-weight-bold",
                                },
                                [_vm._v("Quote Builder")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedAddItemsTab == _vm.addItemsTabs.templates.key
                        ? _c(
                            "div",
                            { staticClass: "is-flex is-align-items-center" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "px-3 is-size-4 has-text-weight-bold",
                                },
                                [_vm._v("Templates")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-grey has-text-grey is-small is-rounded px-0 is-ghost mr-1 mt-3",
                            on: { click: _vm.handleToggleAvaliableItems },
                          },
                          [
                            _c("span", { staticClass: "msr msr-24px" }, [
                              _vm._v(" close "),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm.selectedAddItemsTab == _vm.addItemsTabs.butterfly.key
                    ? _c(
                        "div",
                        {
                          staticClass: "tabs",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            width: "100%",
                          },
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticStyle: {
                                display: "flex",
                                width: "100%",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "li",
                                {
                                  class: {
                                    "is-active":
                                      _vm.avaliableItemsType == "PARTS",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAvaliableItemsType("PARTS")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: {
                                        "has-text-grey":
                                          _vm.avaliableItemsType != "PARTS",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-24px mr-2" },
                                        [_vm._v("car_tag")]
                                      ),
                                      _vm._v(" Parts "),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  class: {
                                    "is-active":
                                      _vm.avaliableItemsType == "LABOUR",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAvaliableItemsType("LABOUR")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: {
                                        "has-text-grey":
                                          _vm.avaliableItemsType != "LABOUR",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-24px mr-2" },
                                        [_vm._v("fragrance")]
                                      ),
                                      _vm._v(" Labour "),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  class: {
                                    "is-active":
                                      _vm.avaliableItemsType == "OTHER",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAvaliableItemsType("OTHER")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: {
                                        "has-text-grey":
                                          _vm.avaliableItemsType != "OTHER",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-24px mr-2" },
                                        [_vm._v("car_repair")]
                                      ),
                                      _vm._v(" Mech "),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  class: {
                                    "is-active":
                                      _vm.avaliableItemsType == "MISC",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAvaliableItemsType("MISC")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: {
                                        "has-text-grey":
                                          _vm.avaliableItemsType != "MISC",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-24px mr-2" },
                                        [_vm._v("water_drop")]
                                      ),
                                      _vm._v(" Misc "),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  class: {
                                    "is-active":
                                      _vm.avaliableItemsType == "SUBLETS",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAvaliableItemsType(
                                        "SUBLETS"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: {
                                        "has-text-grey":
                                          _vm.avaliableItemsType != "SUBLETS",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-24px mr-2" },
                                        [_vm._v("compass_calibration")]
                                      ),
                                      _vm._v(" Sublets "),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  (!!_vm.isAvailableItemsOpen || !!_vm.isAvailableMainActive) &&
                  _vm.avaliableItemsType == "LABOUR" &&
                  _vm.isNtar &&
                  _vm.selectedAddItemsTab == _vm.addItemsTabs.butterfly.key
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-align-items-center is-justify-content-space-between mb-2",
                        },
                        [
                          _c("div"),
                          _c("div", { staticClass: "control" }, [
                            _c("label", { staticClass: "radio" }, [
                              _c("input", {
                                attrs: { type: "radio", name: "answer" },
                                domProps: { checked: _vm.isSundry },
                                on: {
                                  click: function ($event) {
                                    _vm.isSundry = true
                                  },
                                },
                              }),
                              _vm._v(" Sundry "),
                            ]),
                            _c("label", { staticClass: "radio" }, [
                              _c("input", {
                                attrs: { type: "radio", name: "answer" },
                                domProps: { checked: !_vm.isSundry },
                                on: {
                                  click: function ($event) {
                                    _vm.isSundry = false
                                  },
                                },
                              }),
                              _vm._v(" Standard "),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  (!!_vm.isAvailableItemsOpen || !!_vm.isAvailableMainActive) &&
                  _vm.avaliableItemsType == "OTHER" &&
                  _vm.selectedAddItemsTab == _vm.addItemsTabs.butterfly.key
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-align-items-center is-justify-content-space-between mb-2",
                        },
                        [
                          _c("div"),
                          _c("div", { staticClass: "control" }, [
                            _c("label", { staticClass: "radio" }, [
                              _c("input", {
                                attrs: { type: "radio", name: "answer" },
                                domProps: { checked: _vm.isLabourOtherNtar },
                                on: {
                                  click: function ($event) {
                                    _vm.isLabourOtherNtar = true
                                  },
                                },
                              }),
                              _vm._v(" NTAR "),
                            ]),
                            _c("label", { staticClass: "radio" }, [
                              _c("input", {
                                attrs: { type: "radio", name: "answer" },
                                domProps: { checked: !_vm.isLabourOtherNtar },
                                on: {
                                  click: function ($event) {
                                    _vm.isLabourOtherNtar = false
                                  },
                                },
                              }),
                              _vm._v(" Standard "),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.selectedAddItemsTab == _vm.addItemsTabs.butterfly.key
                    ? _c("add-items-component", {
                        attrs: {
                          value: _vm.value,
                          vehicle: _vm.vehicle,
                          "is-sundry": _vm.isSundry,
                          "next-line-number": _vm.nextLineNumber,
                          "is-available-items-active": _vm.isAvailableItemsOpen,
                          "avaliable-items-type": _vm.avaliableItemsType,
                          "is-main-active": _vm.isAvailableMainActive,
                          "selected-sub-sections": _vm.localSelectedSubSections,
                          "selected-area": _vm.selectedArea,
                          "is-labour-other-ntar": _vm.isLabourOtherNtar,
                        },
                        on: { handleUpdate: _vm.handleUpdate },
                      })
                    : _vm._e(),
                  _vm.selectedAddItemsTab == _vm.addItemsTabs.templates.key
                    ? _c("template-component", {
                        attrs: {
                          "quote-times-type": _vm.value.labourType,
                          "vehicle-body-id": _vm.vehicle.bodyId,
                          "quote-no": _vm.value.quoteNo,
                          rates: _vm.value.rates,
                          tags: _vm.tags,
                          "tag-category-id": _vm.tagCategory.tagCategoryID,
                          "show-manage-tag": _vm.showQuoteTemplate,
                        },
                        on: {
                          addRepairQuoteTemplateItems: (id) =>
                            _vm.$emit("addRepairQuoteTemplateItems", id),
                          addTemplateItemsCustom: (obj) =>
                            _vm.$emit("handleAddTemplateItemsCustom", obj),
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "article",
            {
              staticClass: "cell tile is-child box p-2",
              class:
                !!_vm.isAvailableItemsOpen || !!_vm.isAvailableMainActive
                  ? "is-col-span-7"
                  : "is-col-span-12",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-align-items-center mb-5 is-justify-content-space-between",
                },
                [
                  _c("div", { staticClass: "is-flex is-align-items-end" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "is-flex ml-2" }, [
                      _c("span", { staticClass: "mr-2" }, [_vm._v("Items:")]),
                      _c(
                        "span",
                        {
                          staticClass: "has-text-success has-text-weight-bold",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.totalQuoteItems,
                                  _vm.$userInfo.locale,
                                  false,
                                  2
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _vm.totalQuoteItems != _vm.value.totalExGst
                      ? _c("div", { staticClass: "is-flex ml-3" }, [
                          _c("span", { staticClass: "mr-2" }, [
                            _vm._v("Grand Total:"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "has-text-success has-text-weight-bold is-underlined is-clickable",
                              on: { click: _vm.handleSummaryClick },
                            },
                            [
                              _c("span", {}, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.value.totalExGst,
                                        _vm.$userInfo.locale,
                                        false,
                                        2
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "is-flex" }, [
                    !_vm.isAvailableItemsOpen && !_vm.isAvailableMainActive
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleOutsideClick,
                                expression: "handleOutsideClick",
                              },
                            ],
                            staticClass: "dropdown",
                            class: {
                              "is-active":
                                _vm.viewOptionDropdownActive &&
                                !_vm.isAvailableItemsOpen,
                              disabled: !!_vm.isAvailableItemsOpen,
                            },
                          },
                          [
                            _c("div", { staticClass: "dropdown-trigger" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-primary is-outlined mx-1",
                                  attrs: {
                                    "aria-haspopup": "true",
                                    "aria-controls": "dropdown-menu",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.viewOptionDropdownActive =
                                        !_vm.viewOptionDropdownActive
                                    },
                                  },
                                },
                                [
                                  _vm.selectedViewType ==
                                  _vm.viewTypes.tabbedView
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-align-items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "msr msr-20px mr-1",
                                            },
                                            [_vm._v("tab")]
                                          ),
                                          _c("span", [_vm._v("Tabs")]),
                                        ]
                                      )
                                    : _vm.selectedViewType ==
                                      _vm.viewTypes.multiColView
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-align-items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "msr msr-22px mr-1",
                                            },
                                            [_vm._v("view_column")]
                                          ),
                                          _c("span", [_vm._v("Dual")]),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-align-items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "msr msr-22px mr-1",
                                            },
                                            [_vm._v("view_stream")]
                                          ),
                                          _c("span", [_vm._v("Full")]),
                                        ]
                                      ),
                                  _c("span", { staticClass: "mso mso-24px" }, [
                                    _vm._v(" keyboard_arrow_down "),
                                  ]),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                attrs: { id: "dropdown-menu", role: "menu" },
                              },
                              [
                                _c("div", { staticClass: "dropdown-content" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item is-flex is-align-items-center has-text-primary",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectedViewType =
                                            _vm.viewTypes.singleColView
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "msr msr-22px mr-1" },
                                        [_vm._v("view_stream")]
                                      ),
                                      _c("span", [_vm._v("Full Screen")]),
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item is-flex is-align-items-center has-text-primary",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectedViewType =
                                            _vm.viewTypes.multiColView
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "msr msr-22px mr-1" },
                                        [_vm._v("view_column")]
                                      ),
                                      _c("span", [_vm._v("Dual Screen")]),
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item is-flex is-align-items-center has-text-primary",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectedViewType =
                                            _vm.viewTypes.tabbedView
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "msr msr-20px mr-1" },
                                        [_vm._v("tab")]
                                      ),
                                      _c("span", [_vm._v("Tabbed View")]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.value.parts.filter(
                      (p) =>
                        p.deleted === false &&
                        !p.isNew &&
                        (p.partStatus == "Exp" || p.partStatus == "Imp")
                    ).length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "button is-outlined mx-1",
                            class:
                              _vm.value.parts.filter(
                                (p) =>
                                  p.deleted === false &&
                                  !p.isNew &&
                                  (p.partStatus == "Exp" ||
                                    p.partStatus == "Imp")
                              ).length > 0
                                ? "is-primary"
                                : `is-outlined-btn-${_vm.$theme.name}`,
                            on: {
                              click: function ($event) {
                                return _vm.$emit("downloadPartsCheckPrice")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "msr msr-24px mr-2" }, [
                              _vm._v(" currency_exchange "),
                            ]),
                            _c("span", [_vm._v("Sync")]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "tooltip is-tooltip-bottom is-tooltip-multiline",
                        staticStyle: { "text-align": "center" },
                        attrs: {
                          "data-tooltip": _vm.value.isAudaNet
                            ? "To adjust a line, please remove it in AudaNet and\ndownload it to FQ."
                            : "Adjust Main Quote Items",
                        },
                      },
                      [
                        _vm.value.subQuoteNo > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "button mx-1 is-success",
                                attrs: { disabled: _vm.value.isAudaNet },
                                on: {
                                  click: _vm.handleToggleAvaliableMainItems,
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "mdi",
                                    class: {
                                      "mdi-adjust": !_vm.isAvailableMainActive,
                                      "mdi-close": _vm.isAvailableMainActive,
                                    },
                                  }),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isAvailableMainActive
                                        ? "Done"
                                        : "Adjust"
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button mx-1 is-outlined",
                          class: _vm.canPriceParts
                            ? "is-success"
                            : `is-outlined-btn-${_vm.$theme.name}`,
                          attrs: { disabled: !_vm.canPriceParts },
                          on: { click: _vm.goToPriceParts },
                        },
                        [
                          _c("span", { staticClass: "msr msr-24px" }, [
                            _vm._v(" price_check "),
                          ]),
                          _c("span", [_vm._v("Price Parts")]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "scrollable-part-items" },
                [
                  _vm.selectedViewType == _vm.viewTypes.tabbedView &&
                  !_vm.isAvailableItemsOpen
                    ? _c("div", { staticClass: "tabs" }, [
                        _c(
                          "ul",
                          _vm._l(_vm.dataTypes, function (tab) {
                            return _c(
                              "li",
                              {
                                key: tab.title,
                                class: {
                                  "is-active": _vm.selectedTab.id == tab.id,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedTab = tab
                                  },
                                },
                              },
                              [
                                _c("a", [
                                  _c("span", [_vm._v(_vm._s(tab.title))]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _c("quote-builder-items-view", {
                    attrs: {
                      "selected-view-type": _vm.selectedViewComputed,
                      "selected-tab": _vm.selectedTab,
                      "view-types": _vm.viewTypes,
                      value: _vm.value,
                      "is-available-items-open": _vm.isAvailableItemsOpen,
                      "avaliable-items-type": _vm.avaliableItemsType,
                      "is-present-as-modal-active": _vm.isPresentAsModalActive,
                      "next-line-number": _vm.nextLineNumber,
                      "is-editable": _vm.isEditable,
                      vehicle: _vm.vehicle,
                    },
                    on: {
                      onOpgCodeChanged: function ($event) {
                        return _vm.$emit("onOpgCodeChanged")
                      },
                      handleUpdate: _vm.handleUpdate,
                      handlePresentAs: _vm.handlePresentAs,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _c("save-template-modal", {
        attrs: {
          active: _vm.isTemplateSaveModalActive,
          "data-types": _vm.dataTypes,
          quote: _vm.value,
          vehicle: _vm.vehicle,
          tags: _vm.tags,
        },
        on: {
          "update:active": function ($event) {
            _vm.isTemplateSaveModalActive = $event
          },
        },
      }),
      _vm.isPresentAsModalActive
        ? _c(
            "quote-item-present-as-modal",
            {
              attrs: {
                active: _vm.isPresentAsModalActive,
                "maximum-options": 2,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isPresentAsModalActive = $event
                },
                ok: function ($event) {
                  return _vm.onPresentAsOk()
                },
                cancel: function ($event) {
                  return _vm.closePresentAsModal()
                },
                close: function ($event) {
                  return _vm.closePresentAsModal()
                },
              },
              model: {
                value: _vm.presentAsItem.presentAs,
                callback: function ($$v) {
                  _vm.$set(_vm.presentAsItem, "presentAs", $$v)
                },
                expression: "presentAsItem.presentAs",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Present As"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "title px-3" }, [_vm._v("Quote Items")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }